<template>
  <v-dialog max-width="600px" :value="visible" @input="$emit('update:visible', $event)" persistent>
    <v-card dark v-if="editableItem">
      <v-card-title class="font-weight-bold contractSettings__dialog-title justify-center mb-5">
        {{ editableItem.title }}
      </v-card-title>
      <v-card-text>
        <v-row no-gutters class="px-5">
          <v-col cols="12">
            <v-text-field v-model="editableItem.title" label="Bezeichnung"></v-text-field>
            <v-textarea v-model="editableItem.description" label="Beschreibung" counter="150"></v-textarea>

            <v-file-input multiple @change="uploadImagesPackage" label="Bilder hochladen" prepend-icon="mdi-camera"></v-file-input>
            <v-row v-if="editableItem.gallery && editableItem.gallery.length > 0" class="mt-2">
              <v-col cols="4" v-for="(image, index) in editableItem.gallery" :key="index">
                <v-img :src="'/api/' + image.src" class="rounded">
                  <v-btn icon small class="float-right" color="red" @click="deleteImagePackage(index)"><v-icon>mdi-close</v-icon></v-btn>
                </v-img>
              </v-col>
            </v-row>

            <v-switch v-model="editableItem.amountSelectable" label="Anzahl auswählbar" class="mt-4"></v-switch>
            <v-switch v-model="editableItem.showAsUpgradePossibility" label="Als Upgrade anzeigen"></v-switch>
            <v-switch
              v-if="editableItem.showAsUpgradePossibility"
              v-model="editableItem.calculateWithEndDate"
              label="Upgrade Anteilsmässig berechnen"></v-switch>
            <v-switch
              v-if="editableItem.showAsUpgradePossibility"
              v-model="editableItem.calculateWithEndDateSixMonths"
              label="Upgrade Rabatt ab 6 Monate 50%"></v-switch>
            <v-switch v-model="editableItem.hideForMinors" label="Für Minderjährige (<18) im online Shop ausblenden"></v-switch>

            <v-select
              label="Studios"
              multiple
              v-model="editableItem.studios"
              :items="studios"
              item-text="name"
              item-value="_id"
              @change="changeStudios"></v-select>
          </v-col>
        </v-row>

        <v-expansion-panels class="mb-5" v-model="panel" multiple>
          <v-expansion-panel v-for="(settings, studioId) in editableItem.studioSettings" :key="studioId">
            <v-expansion-panel-header>{{ getStudioName(studioId) }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-select
                label="Für Mitgliedschaften auswählen"
                multiple
                v-model="settings.memberships"
                :items="memberships.filter((m) => m.studios.includes(studioId))"
                item-text="title"
                return-object
                @change="changeMembershipsInPackage(studioId)"></v-select>
              <v-col cols="12">
                <v-switch
                  label="zusätzliche Bestätigung erforderlich"
                  v-model="settings.showAdditionalConfirmation"
                  @change="changeAdditionalConfirmation"></v-switch>
              </v-col>

              <v-col cols="12" class="py-0" v-if="settings.showAdditionalConfirmation">
                <v-textarea placeholder="Text für zusätzliche Bestätigung" v-model="settings.additionalConfirmationText"></v-textarea>
              </v-col>

              <v-col cols="12">
                <v-switch
                  label="zusätzliche Information anzeigen (auch Printversion)"
                  v-model="settings.showAdditionalInfoPrint"
                  @change="changeAdditionalConfirmation"></v-switch>
              </v-col>

              <v-col cols="12" class="py-0" v-if="settings.showAdditionalInfoPrint">
                <v-text-field
                  placeholder="Text für zusätzliche Information (auch Print)"
                  v-model="settings.showAdditionalInfoPrintText"></v-text-field>
              </v-col>
              <v-expansion-panels>
                <v-expansion-panel v-for="(membership, j) in settings.memberships" :key="j + '-pkg-mem'">
                  <v-expansion-panel-header>{{ membership.title }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-if="!membership.flexActive">
                      <div v-for="(duration, k) in membership.packageDurations" :key="k + '-pkg-dur'">
                        <v-text-field type="number" v-model.number="duration.packagePrice" :label="getDurationLabel(duration)"></v-text-field>
                      </div>
                    </div>
                    <div v-else>
                      <v-text-field type="number" v-model.number="membership.packageFlex.price" label="Preis"></v-text-field>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions class="contractSettings__dialog-actions">
        <v-btn class="white--text" text @click="$emit('update:visible', false)">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="white--text" text @click="$emit('save', { item: editableItem, type: 'package' })">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api"

export default {
  name: "PackageEditor",
  props: ["visible", "item", "studios", "memberships"],
  data() {
    return {
      editableItem: null,
      panel: [],
    }
  },
  watch: {
    item: {
      handler(newItem) {
        this.editableItem = newItem ? JSON.parse(JSON.stringify(newItem)) : null
      },
      immediate: true,
    },
  },
  methods: {
    // KORRIGIERT: Fehlende Methode hinzugefügt
    changeAdditionalConfirmation() {
      this.$forceUpdate()
    },
    getStudioName(studioId) {
      const studio = this.studios.find((s) => s._id === studioId)
      return studio ? studio.name : "Unbekanntes Studio"
    },
    getDurationLabel(duration) {
      let label = []
      if (duration.years > 0) label.push(`${duration.years}J`)
      if (duration.months > 0) label.push(`${duration.months}M`)
      if (duration.days > 0) label.push(`${duration.days}T`)
      return label.join(" / ") || "Laufzeit"
    },
    changeStudios() {
      const newSettings = {}
      this.editableItem.studios.forEach((studioId) => {
        // KORRIGIERT: Initialisierung der neuen Felder
        newSettings[studioId] = this.editableItem.studioSettings[studioId] || {
          memberships: [],
          showAdditionalConfirmation: false,
          additionalConfirmationText: "",
          showAdditionalInfoPrint: false,
          showAdditionalInfoPrintText: "",
        }
      })
      this.editableItem.studioSettings = newSettings
    },
    changeMembershipsInPackage(studioId) {
      // Deine Logik hier ist komplex, aber im Kern korrekt.
      // Sie stellt sicher, dass die Laufzeiten korrekt von der Haupt-Mitgliedschaft übernommen werden.
      const studioMemberships = this.editableItem.studioSettings[studioId].memberships
      studioMemberships.forEach((membership, index) => {
        if (!membership.packageDurations && !membership.packageFlex) {
          const originalMembership = this.memberships.find((om) => om._id === membership._id)
          if (!originalMembership) return

          const newMembershipData = JSON.parse(JSON.stringify(originalMembership))

          if (newMembershipData.flexActive) {
            this.$set(newMembershipData, "packageFlex", { price: 0 })
          } else {
            const packageDurations = newMembershipData.studioSettings[studioId]?.durations.map((d) => ({
              ...d,
              packagePrice: 0,
            }))
            this.$set(newMembershipData, "packageDurations", packageDurations || [])
          }
          this.$set(this.editableItem.studioSettings[studioId].memberships, index, newMembershipData)
        }
      })
    },
    uploadImagesPackage(files) {
      for (let file of files) {
        const formData = new FormData()
        formData.append("file", file)
        api.uploadContractPicture(formData).then((response) => {
          if (!this.editableItem.gallery) {
            this.$set(this.editableItem, "gallery", [])
          }
          this.editableItem.gallery.push({ src: response.name })
        })
      }
    },
    deleteImagePackage(index) {
      this.editableItem.gallery.splice(index, 1)
    },
  },
}
</script>
